import React, { useEffect, useState } from "react";
import {
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  FormControl,
  FormControlLabel,
  CircularProgress,
  Backdrop,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useNotify } from "react-admin";
import { logError } from "../../utils/appUtils";
import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: "transparent",
  },
  checkIcon: {
    color: theme.palette.type === "dark" ? "white" : grey[800],
  },
  backdrop: {
    zIndex: 90001,
  },
}));

export const ChecklistDialog = ({
  model,
  saveModel,
  stepName,
  isOpen,
  setOpen,
  title,
  readonly,
  showAllSteps,
}) => {
  const [checklistItems, setCheklistItems] = useState([]);
  const [showAll, setShowAll] = useState(showAllSteps);
  const [loading, setLoading] = useState(false);
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const classes = useStyles();
  const notify = useNotify();

  useEffect(() => {
    if (!model?.id) return;
    setCheklistItems(model.checklist);
  }, [model]);

  const handleSave = async () => {
    if (readonly) return;
    try {
      debugger;
      setLoading(true);
      model.checklist = checklistItems;
      await saveModel(model);
      setOpen(false);
    } catch (err) {
      logError("ChecklistDialog:handleSave", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const handleComplete = (checklistItem) => {
    if (readonly) return;
    checklistItem.isCompleted = !checklistItem.isCompleted;
    checklistItem.completedBy = window.appUser?.fullName;
    checklistItem.completedAt = new Date();
    setCheklistItems(
      checklistItems.map((itm) =>
        itm.name === checklistItem.name ? checklistItem : itm
      )
    );
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const getFilteredChecklistItems = () => {
    if (!checklistItems) return [];
    if (showAll === "all") return checklistItems;
    const checklist = checklistItems.filter((itm) => itm.stepName === stepName);
    return checklist;
  };

  return (
    <Dialog
      open={isOpen}
      maxWidth={isSmall ? null : "md"}
      fullWidth={isSmall ? false : true}
      fullScreen={isSmall}
    >
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        component="span"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        m={2}
      >
        <Typography variant="h6">{title || "Checklist"}</Typography>
        <CancelOutlinedIcon fontSize="large" onClick={handleCancel} />
      </Box>
      <DialogContent>
        {stepName && (
          <Box
            display="flex"
            justifyContent="flex-end"
            onChange={(evt) => setShowAll(evt.target.value)}
          >
            <FormControl component="fieldset">
              <RadioGroup row name="show" defaultValue="step">
                <FormControlLabel
                  value="step"
                  control={<Radio color="primary" />}
                  label={stepName}
                />
                <FormControlLabel
                  value="all"
                  control={<Radio color="primary" />}
                  label="All Steps"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
        <List dense>
          {checklistItems &&
            getFilteredChecklistItems().map((itm) => (
              <ListItem
                divider
                key={itm.name}
                onClick={() => handleComplete(itm)}
              >
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    {itm.isCompleted ? (
                      <CheckBoxOutlinedIcon className={classes.checkIcon} />
                    ) : (
                      <CheckBoxOutlineBlankOutlinedIcon
                        className={classes.checkIcon}
                      />
                    )}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={itm.name}
                  secondary={
                    <Typography variant="body2" color="textSecondary">
                      {itm.description}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Box>
          <Button onClick={() => handleCancel()}>Cancel</Button>
          <Button
            type="submit"
            onClick={() => handleSave()}
            color="primary"
            disabled={loading}
          >
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
